enum FlaggedFormCategories {
  ACTIVITY = 'activity',
  DELIVERY = 'delivery',
  ENVIRONMENTAL = 'environmental',
  EQUIPMENT = 'equipment',
  MATERIAL = 'material',
  QUALITY = 'quality',
  REPORT = 'report',
  SAFETY = 'safety',
  SITE_COMMUNICATION = 'site_communication',
}

export const flaggedFormCategoriesList = Object.values(FlaggedFormCategories)

export default FlaggedFormCategories
